
import AuthLayoutTemplate from '@/layouts/auth/auth-simple-layout';

export default function AuthLayout({
    children,
    title,
    description,
    status,
    canResetPassword,
    canRegister,
    ...props
}: {
    children: React.ReactNode;
    title: string;
    description: string;
    status?: string;
    canResetPassword?: boolean;
    canRegister?: boolean;
}) {
    return (
        <AuthLayoutTemplate 
            title={title} 
            description={description} 
            status={status}
            canResetPassword={canResetPassword}
            canRegister={canRegister}
            {...props}
        >
            {children}
        </AuthLayoutTemplate>
    );
}
